import React from 'react';

export const Form = ({ children, className = '', ...props }: React.FormHTMLAttributes<HTMLFormElement>) => (
  <form className={`space-y-4 ${className}`} {...props}>
    {children}
  </form>
);

export const FormGroup = ({ children, className = '' }: { children: React.ReactNode; className?: string }) => (
  <div className={`flex flex-col gap-1.5 ${className}`}>
    {children}
  </div>
);

export const FormLabel = ({ children, required, className = '', ...props }: React.LabelHTMLAttributes<HTMLLabelElement> & { required?: boolean }) => (
  <label className={`text-sm font-medium text-gray-700 ${className}`} {...props}>
    {children}
    {required && <span className="text-red-500 ml-1">*</span>}
  </label>
);

export const FormError = ({ children, className = '' }: { children?: React.ReactNode; className?: string }) => {
  if (!children) return null;
  return <p className={`text-xs text-red-500 mt-1 ${className}`}>{children}</p>;
};
